export class EventsTags {
    events: number[];
    tags: number[];

    constructor(eventIds: number[], tagIds: number[]) {
        this.events = eventIds;
        this.tags = tagIds;
    }
}
